export default class UserQuestaoOrdem {
  constructor({ streamId, raised, dataHora }) {
    this.streamId = streamId
    this.raised = raised
    this.dataHora = dataHora
  }
}
